import { createGlobalStyle } from "styled-components";
const GlobalStyle = createGlobalStyle`
    :root {
    }

    * {
        padding: 0;
        margin: 0;
        text-decoration: none;
        box-sizing: border-box;
    }

    body {
        font-family: 'Poppins', sans-serif;
        background-color: ${(props) => props.theme.THEME.background};
        margin: 0;
        padding: 0;
        overflow-x: hidden;
    }

    button {
        cursor: pointer;
    }

    [disabled] {
        opacity: 0.6
        cursor: not-allowed;
    }

`;

export default GlobalStyle;
